module.exports = __webpack_public_path__ + "static/img/logo.358d96dd.svg";